export default __webpack_public_path__ + "static/media/docs.5a3c35a7.svg";